module.exports = __webpack_public_path__ + "img/google.7ecca015.svg";